/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveDocumentCommand
 */
export interface RemoveDocumentCommand {
    /**
     * 
     * @type {boolean}
     * @memberof RemoveDocumentCommand
     */
    permanentlyDeleteFile: boolean;
}

export function RemoveDocumentCommandFromJSON(json: any): RemoveDocumentCommand {
    return {
        'permanentlyDeleteFile': json['permanentlyDeleteFile'],
    };
}

export function RemoveDocumentCommandToJSON(value?: RemoveDocumentCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'permanentlyDeleteFile': value.permanentlyDeleteFile,
    };
}


